export const hasEditorText = (html?: string | null): boolean => {
  if (!html) {
    return false;
  }

  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/&(?:amp|lt|gt|quot|#39);/gi, 'x')
    .trim()
    .length > 0;
};
